import { LitElement } from 'lit';

export class Accordion extends LitElement {
  static properties = {
    accordionStyle: { type: String, attribute: 'accordion-style' }
  };

  createRenderRoot() {
    return this; // Use light DOM instead of shadow DOM
  }

  constructor() {
    super();
    this.accordionStyle = 'normal';
  }

  connectedCallback() {
    super.connectedCallback();
    // PHP generates all the markup, we just need the container element
    // Add any accordion-level initialization here if needed
  }
}
